import axios from "axios";
import { useState, useEffect } from "react";
import { BASE_URL } from "../../config/axios";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/images/website/logo.png"
import DiwaliGif from "../../assets/images/Purple Neon Diwali Greeting YouTube Video.gif"
import { handleErrorToast } from "../../components/custom"
import { ToastContainer, toast } from "react-toastify";
import { motion } from "framer-motion";
import {
  Eye,
  EyeOff,
  Lock,
  Mail,
  ArrowRight,
  Shield,
  Building2,
  Sparkles,
  Key,
  CheckCircle,
  UserCog
} from "lucide-react";

const Login = () => {
  const navigate = useNavigate();
  const [errMsg, setErrMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });


  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [showPassword, setShowPassword] = useState(false);


  useEffect(() => {
    // Check if the fields have been auto-filled by the browser
    const emailInput = document.getElementById('email');
    const passwordInput = document.getElementById('password');
    if (emailInput && passwordInput) {
      setFormData({
        email: emailInput.value,
        password: passwordInput.value
      });
      setInputState({
        email: emailInput.value ? 'green' : '',
        password: passwordInput.value ? 'green' : '',
      });
    }
  }, []);


  const validateForm = () => {
    const newErrors = {};
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    }
    else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      newErrors.email = 'Invalid email format';
    }

    const requiredFields = [
      'password',
    ];

    requiredFields.forEach(field => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const [loading, setLoading] = useState(false); //loading logic

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsLoading(true);
      const logingToastId = toast.loading("Authenticating...", {
        position: "top-center",
        theme: "colored"
      });
      try {
        let res = await axios.post(`${BASE_URL}/user/login/`, formData);
        console.log("res")
        console.log(res)
        if (res.status === 200) {
          toast.success(`Logging In...`);
          const { access, refresh, payload, payload_a } = res.data;
          const sessionData = {
            access_token: access,
            refresh_token: refresh,
            role: payload.role,
            email: payload.email,
            employee_id: payload_a.emp_code,
            profilepic: payload_a.profilepic,
            reportinghead: payload_a.reporting_head,
            department: payload_a.department_name,
            departmentid: payload_a.department,
            pr_project: payload_a.pr_project,
            view_all_project: payload_a.view_all_project,
            edit_project_access: payload_a.edit_project_access,
            delete_project_access: payload_a.delete_project_access,
            name: payload_a.name,
            sub_company_id: payload_a.sub_company_id,
            sub_company_name: payload_a.division_name
          };
          console.log("payload_a")
          console.log(payload_a)

          Object.entries(sessionData).forEach(([key, value]) => sessionStorage.setItem(key, value));
          navigate("/");
          window.location.reload();
        }
        else {
          setErrMsg("Invalid Email Or Password")
        }
      }
      catch (err) {
        console.log(err);
        setErrMsg(err.response.data.error);
        // setErrMsg("Invalid Email Or Password");
        handleErrorToast(err, logingToastId);


      } finally {
        setIsLoading(false);  //loading logic
        toast.dismiss(logingToastId);
      }
    }
    else {
      console.log('Form contains errors:', errors);
    }
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? 'green' : '',
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const forgotpass = () => {
    navigate("/forgotpassword");
  }

  const handleKeyPress = (event) => {
    // Check if the pressed key is Enter (key code 13)
    if (event.key === 'Enter') {
      event.preventDefault();  // Prevent the default form submission
      handleSubmit(event);
    }
  };


  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <div className="modern-login-container">
        {/* Left Section - Branding & Visuals */}
        <div className="login-left-section">
          <motion.div
            className="animated-background"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
          >
            <div className="floating-shapes">
              {[...Array(8)].map((_, i) => (
                <motion.div
                  key={i}
                  className="floating-shape"
                  animate={{
                    y: [0, -20, 0],
                    x: [0, i % 2 === 0 ? 10 : -10, 0],
                    rotate: [0, i % 2 === 0 ? 180 : -180, 0]
                  }}
                  transition={{
                    duration: 10 + i * 2,
                    repeat: Infinity,
                    ease: "easeInOut"
                  }}
                />
              ))}
            </div>
          </motion.div>

          <div className="login-left-content">
            <motion.div
              className="login-logo-container"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <Link to="/">
                <img src={Logo} alt="Company Logo" className="login-logo" />
              </Link>
              <div className="company-brand">
                <motion.div
                  className="brand-icon"
                  animate={{
                    scale: [1, 1.1, 1],
                    rotate: [0, 5, -5, 0]
                  }}
                  transition={{ duration: 3, repeat: Infinity }}
                >
                  <Sparkles size={32} />
                </motion.div>
                <h1>Prebid Portal</h1>
              </div>
              <p className="company-tagline">Your Gateway to Seamless Project Management</p>
            </motion.div>

            <motion.div
              className="login-features"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <div className="feature-card">
                <div className="feature-icon">
                  <UserCog size={24} />
                </div>
                <div>
                  <h4>Role-Based Access</h4>
                  <p>Customized dashboard for every team member</p>
                </div>
              </div>
              <div className="feature-card">
                <div className="feature-icon">
                  <Building2 size={24} />
                </div>
                <div>
                  <h4>Real-time Updates</h4>
                  <p>Stay updated with live project progress</p>
                </div>
              </div>

            </motion.div>
          </div>
        </div>

        {/* Right Section - Login Form */}
        <div className="login-right-section">
          <div className="login-form-wrapper">
            <motion.div
              className="login-form-card"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
            >
              <div className="form-header">
                <motion.div
                  className="header-icon"
                  animate={{
                    rotate: [0, 360],
                    scale: [1, 1.1, 1]
                  }}
                  transition={{
                    rotate: { duration: 20, repeat: Infinity, ease: "linear" },
                    scale: { duration: 2, repeat: Infinity }
                  }}
                >
                  <Key size={40} />
                </motion.div>
                <div>
                  <h2>Welcome Back</h2>
                  <p style={{ margin: "0px" }} className="header-subtitle">Sign in to continue to your dashboard</p>
                </div>
              </div>

              <motion.form
                onSubmit={handleSubmit}
                onKeyDown={handleKeyPress}
                className="modern-login-form"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    <Mail size={18} />
                    <span>Email Address</span>
                  </label>
                  <div className={`input-container ${errors.email ? 'input-error' : inputState.email ? 'input-valid' : ''}`}>
                    <input
                      type="text"
                      id="email"
                      name="email"
                      placeholder="Enter your work email"
                      autoComplete="email"
                      onChange={handleInputChange}
                      value={formData.email}
                      className="form-input"
                      disabled={isLoading}
                    />
                    {inputState.email === 'valid' && !errors.email && (
                      <CheckCircle size={18} className="input-icon-valid" />
                    )}
                  </div>
                  {errors.email && (
                    <motion.span
                      className="error-message"
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: 'auto' }}
                    >
                      {errors.email}
                    </motion.span>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="password" className="form-label">
                    <Lock size={18} />
                    <span>Password</span>
                  </label>
                  <div className={`input-container ${errors.password ? 'input-error' : inputState.password ? 'input-valid' : ''}`}>
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      id="password"
                      name="password"
                      onChange={handleInputChange}
                      value={formData.password}
                      className="form-input"
                      disabled={isLoading}
                    />
                    <button
                      type="button"
                      className="password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                      disabled={isLoading}
                    >
                      {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                    </button>
                  </div>
                  {errors.password && (
                    <motion.span
                      className="error-message"
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: 'auto' }}
                    >
                      {errors.password}
                    </motion.span>
                  )}
                </div>

                <div className="form-options">
                  <div></div>
                  <motion.button
                    type="button"
                    className="forgot-password-link"
                    onClick={forgotpass}
                    disabled={isLoading}
                    whileHover={{ x: 5 }}
                  >
                    Forgot Password?
                  </motion.button>
                </div>

                <motion.button
                  type="submit"
                  className="login-button"
                  disabled={isLoading}
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 0.97 }}
                >

                  <span>Sign In</span>
                  <motion.div
                    animate={{ x: [0, 5, 0] }}
                    transition={{ duration: 1, repeat: Infinity }}
                  >
                    <ArrowRight size={20} />
                  </motion.div>

                </motion.button>

                {errMsg && (
                  <motion.div
                    className="error-alert"
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                  >
                    <Shield size={16} />
                    <span>{errMsg}</span>
                  </motion.div>
                )}
              </motion.form>
            </motion.div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .modern-login-container {
          display: flex;
          min-height: 100vh;
          background: linear-gradient(135deg, #b1282a 0%, #0879dd  50%, #0879dd  100%);
          position: relative;
          overflow: hidden;
        }

        /* Animated Background */
        .animated-background {
          position: absolute;
          inset: 0;
          background: 
            radial-gradient(circle at 20% 80%, rgba(255,255,255,0.1) 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, rgba(255,255,255,0.1) 0%, transparent 50%),
            radial-gradient(circle at 40% 40%, rgba(255,255,255,0.05) 0%, transparent 50%);
        }

        .floating-shapes {
          position: absolute;
          inset: 0;
        }

        .floating-shape {
          position: absolute;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 50%;
        }

        .floating-shape:nth-child(1) { width: 100px; height: 100px; top: 10%; left: 10%; }
        .floating-shape:nth-child(2) { width: 150px; height: 150px; top: 60%; left: 20%; }
        .floating-shape:nth-child(3) { width: 80px; height: 80px; top: 30%; left: 80%; }
        .floating-shape:nth-child(4) { width: 120px; height: 120px; top: 70%; left: 70%; }
        .floating-shape:nth-child(5) { width: 60px; height: 60px; top: 20%; left: 40%; }
        .floating-shape:nth-child(6) { width: 90px; height: 90px; top: 50%; left: 90%; }
        .floating-shape:nth-child(7) { width: 110px; height: 110px; top: 85%; left: 30%; }
        .floating-shape:nth-child(8) { width: 70px; height: 70px; top: 40%; left: 60%; }

        /* Left Section */
        .login-left-section {
          flex: 1.2;
          color: white;
          padding: 60px 40px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;
          z-index: 1;
        }

        .login-left-content {
          position: relative;
          z-index: 2;
          max-width: 600px;
          margin: 0 auto;
          width: 100%;
        }

      

        .login-logo {
          width: 140px;
          height: auto;
          margin-bottom: 24px;
          filter: brightness(0) invert(1);
          animation: float 3s ease-in-out infinite;
        }

        .company-brand {
          display: flex;
          align-items: center;
          gap: 16px;
          margin-bottom: 16px;
        }

        .brand-icon {
          width: 64px;
          height: 64px;
          border-radius: 20px;
          background: linear-gradient(135deg, #ffffff 0%, rgba(255,255,255,0.8) 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 10px 30px rgba(0,0,0,0.2);
        }

        .brand-icon svg {
          color: #764ba2;
        }

        .company-brand h1 {
          font-size: 36px;
          font-weight: 800;
          background: linear-gradient(135deg, #ffffff 0%, #e6e6e6 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }

        .company-tagline {
          font-size: 18px;
          color: rgba(255, 255, 255, 0.9);
          font-weight: 300;
          line-height: 1.6;
        }

        .login-features {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }

        .feature-card {
          display: flex;
          align-items: center;
          gap: 20px;
          padding: 24px;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          border-radius: 20px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          transition: all 0.3s ease;
        }

        .feature-card:hover {
          background: rgba(255, 255, 255, 0.15);
          transform: translateX(10px);
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
        }

        .feature-icon {
          width: 56px;
          height: 56px;
          border-radius: 16px;
          background: linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .feature-icon svg {
          color: white;
          width: 24px;
          height: 24px;
        }

        .feature-card h4 {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 4px;
          color: white;
        }

        .feature-card p {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.8);
          line-height: 1.5;
        }

        /* Right Section */
        .login-right-section {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 40px;
          background: white;
          position: relative;
          overflow: hidden;
        }

        .login-right-section::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M11 18a3 3 90 1 1 0 6a3 3 90 1 1 0-6zM31 32a3 3 90 1 1 0 6a3 3 90 1 1 0-6zM63 19a3 3 90 1 1 0 6a3 3 90 1 1 0-6zM77 36a3 3 90 1 1 0 6a3 3 90 1 1 0-6z" fill="rgba(118,75,162,0.03)"/></svg>');
          opacity: 0.5;
        }

        .login-form-wrapper {
          width: 100%;
          max-width: 480px;
          position: relative;
          z-index: 1;
        }

        .login-form-card {
          background: white;
          border-radius: 24px;
          padding: 48px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
          border: 1px solid rgba(118, 75, 162, 0.1);
          backdrop-filter: blur(10px);
        }

        .form-header {
          text-align: center;
          margin-bottom: 40px;
        }

        .header-icon {
          width: 80px;
          height: 80px;
          margin: 0 auto 20px;
          background: linear-gradient(135deg, #0879dd  0%, #764ba2 100%);
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
        }

        .form-header h2 {
          font-size: 32px;
          font-weight: 700;
          color: #1a202c;
          margin-bottom: 8px;
          background: linear-gradient(135deg, #0879dd  0%, #764ba2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .header-subtitle {
          font-size: 16px;
          color: #718096;
          font-weight: 400;
        }

        /* Form Styles */
        .modern-login-form {
          display: flex;
          flex-direction: column;
          gap: 28px;
        }

        .form-group {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .form-label {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 15px;
          font-weight: 600;
          color: #2d3748;
          margin:0px;
          
        }

        .form-label svg {
          color: #764ba2;
        }

        .input-container {
          position: relative;
          border-radius: 16px;
          background: #f7fafc;
          border: 2px solid transparent;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          overflow: hidden;
        }

        .input-container:focus-within {
          border-color: #764ba2;
          background: white;
          box-shadow: 0 10px 25px rgba(118, 75, 162, 0.1);
          transform: translateY(-2px);
        }

        .input-container.input-error {
          border-color: #fc8181;
          background: #fff5f5;
          animation: shake 0.5s ease-in-out;
        }

        .input-container.input-valid {
          border-color: #48bb78;
          background: #f0fff4;
        }

        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          75% { transform: translateX(5px); }
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }

        .form-input {
          width: 100%;
          border: none;
          margin:0px;
          background: transparent;
          font-size: 16px;
          color: #2d3748;
          outline: none;
          border-radius: 16px;
          font-family: inherit;
        }

        .form-input::placeholder {
          color: #a0aec0;
        }

        .form-input:disabled {
          cursor: not-allowed;
          opacity: 0.7;
        }

        .password-toggle {
          position: absolute;
          right: 20px;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          color: #a0aec0;
          cursor: pointer;
          padding: 8px;
          border-radius: 10px;
          transition: all 0.2s;
          background: rgba(118, 75, 162, 0.05);
        }

        .password-toggle:hover:not(:disabled) {
          color: #764ba2;
          background: rgba(118, 75, 162, 0.1);
        }

        .password-toggle:disabled {
          cursor: not-allowed;
          opacity: 0.6;
        }

        .input-icon-valid {
          position: absolute;
          right: 20px;
          top: 50%;
          transform: translateY(-50%);
          color: #48bb78;
        }

        .error-message {
          font-size: 14px;
          color: #fc8181;
          margin-top: 6px;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        /* Form Options */
        .form-options {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;
        }

        .checkbox-container {
          display: flex;
          align-items: center;
          cursor: pointer;
          font-size: 15px;
          color: #4a5568;
          user-select: none;
          transition: all 0.2s;
        }

        .checkbox-container:hover {
          color: #764ba2;
        }

        .checkbox-container input {
          display: none;
        }

        .checkmark {
          width: 22px;
          height: 22px;
          border: 2px solid #e2e8f0;
          border-radius: 8px;
          margin-right: 12px;
          position: relative;
          transition: all 0.2s;
          background: white;
        }

        .checkbox-container input:checked + .checkmark {
          background: #764ba2;
          border-color: #764ba2;
          animation: pop 0.3s ease;
        }

        @keyframes pop {
          0% { transform: scale(0.8); }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }

        .checkmark::after {
          content: '';
          position: absolute;
          display: none;
          left: 7px;
          top: 3px;
          width: 6px;
          height: 12px;
          border: solid white;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
        }

        .checkbox-container input:checked + .checkmark::after {
          display: block;
        }

        .forgot-password-link {
          background: none;
          border: none;
          color: #0879dd ;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s;
          padding: 8px 12px;
          border-radius: 10px;
          position: relative;
          overflow: hidden;
        }

        .forgot-password-link::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 2px;
          background: #0879dd ;
          transform: scaleX(0);
          transition: transform 0.3s ease;
        }

        .forgot-password-link:hover:not(:disabled)::after {
          transform: scaleX(1);
        }

        .forgot-password-link:disabled {
          cursor: not-allowed;
          opacity: 0.6;
        }

        /* Login Button */
        .login-button {
          background: linear-gradient(135deg, #0879dd  0%, #764ba2 100%);
          color: white;
          border: none;
          border-radius: 16px;
          font-size: 17px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
          margin-top: 0px;
          position: relative;
          overflow: hidden;
          width:90%
        }

        .login-button::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
          transition: 0.5s;
        }

        .login-button:hover:not(:disabled)::before {
          left: 100%;
        }

        .login-button:hover:not(:disabled) {
          transform: translateY(-3px);
          box-shadow: 0 15px 35px rgba(102, 126, 234, 0.4);
        }

        .login-button:active:not(:disabled) {
          transform: translateY(-1px);
        }

        .login-button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none !important;
        }

        .loading-spinner {
          width: 26px;
          height: 26px;
          border: 3px solid rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          border-top-color: white;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        /* Error Alert */
        .error-alert {
          background: linear-gradient(135deg, #fff5f5 0%, #fed7d7 100%);
          border: 2px solid #fc8181;
          color: #c53030;
          padding: 16px 20px;
          border-radius: 16px;
          font-size: 15px;
          display: flex;
          align-items: center;
          gap: 12px;
          margin: 10px 0;
          animation: slideIn 0.3s ease;
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .error-alert svg {
          flex-shrink: 0;
        }

        /* Form Footer */
        .form-footer {
          text-align: center;
          padding-top: 20px;
          margin-top: 20px;
          border-top: 1px solid #e2e8f0;
        }

        .security-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 10px 20px;
          background: #f7fafc;
          border-radius: 20px;
          font-size: 14px;
          color: #718096;
          font-weight: 500;
        }

        .security-badge svg {
          color: #764ba2;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .modern-login-container {
            flex-direction: column;
          }
          
          .login-left-section {
            padding: 40px 20px;
          }
          
          .login-right-section {
            padding: 40px 20px;
          }
          
          .login-form-card {
            padding: 32px;
          }
          
          .company-brand h1 {
            font-size: 28px;
          }
        }

        @media (max-width: 640px) {
          .login-left-section,
          .login-right-section {
            padding: 30px 16px;
          }
          
          .login-form-card {
            padding: 24px;
          }
          
          .form-header h2 {
            font-size: 24px;
          }
          
          .company-brand h1 {
            font-size: 22px;
          }
          
          .feature-card {
            padding: 16px;
          }
          
          .feature-icon {
            width: 48px;
            height: 48px;
          }
        }

        @media (max-width: 480px) {
          .company-brand {
            flex-direction: column;
            text-align: center;
          }
          
          .form-options {
            flex-direction: column;
            align-items: flex-start;
            gap: 16px;
          }
          
          .login-button {
            padding: 18px 20px;
          }
        }
      `}</style>
    </>
  )
}

export default Login